/* OFF BAPOK — Bento × Laal Paar behaviours: scroll reveal, Pujo day-count, shop filter chips, 2× hover zoom. No per-frame work. */
(() => {
  if (window.__obBento) return; window.__obBento = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* scroll reveal */
  function reveal() {
    const els = $$('[data-reveal]:not(.in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver(es => es.forEach(x => { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -6% 0px', threshold: .08 });
    els.forEach(e => io.observe(e));
  }

  /* days to Shashthi (IST, whole days; never negative) */
  function days() {
    $$('[data-days][data-target]').forEach(el => {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.dataset.target || ''); if (!m) return;
      const t = Date.UTC(+m[1], +m[2] - 1, +m[3]), n = new Date(Date.now() + 5.5 * 3600e3), today = Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate());
      el.textContent = Math.max(0, Math.round((t - today) / 864e5));
    });
  }

  /* shop chips: filter by fit / collection (data attributes come from Shopify, never from the URL) */
  function chips() {
    const grid = $('#obGrid'); if (!grid) return;
    const bar = $('.chips'); if (!bar) return;
    bar.addEventListener('click', e => {
      const b = e.target.closest('.chip'); if (!b) return; const k = b.dataset.k;
      $$('.chip', bar).forEach(c => c.setAttribute('aria-pressed', c === b));
      $$('.pc', grid).forEach(c => {
        const fit = c.dataset.fit, cols = (c.dataset.cols || '').split(' ');
        c.hidden = !(k === 'all' || (k === 'men' && (fit === 'men' || fit === 'unisex')) || (k === 'women' && (fit === 'women' || fit === 'unisex')) || cols.includes(k));
      });
    });
  }

  /* 2× zoom for product mockups (mouse: hover follows the cursor; touch/keyboard: toggle) */
  function zoomable(stage) {
    if (!stage || stage._zoom) return; stage._zoom = true; stage.classList.add('ob-zoomable');
    const coarse = matchMedia('(pointer: coarse)').matches;
    const at = e => { const r = stage.getBoundingClientRect(); stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%'); stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'); };
    const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ob-zoomhint'; btn.textContent = coarse ? 'Tap to zoom 2×' : 'Hover to zoom 2× · click for full view'; btn.setAttribute('aria-pressed', 'false');
    const set = v => { stage.classList.toggle('is-zoom', v); btn.setAttribute('aria-pressed', v); btn.textContent = v ? 'Zoomed 2×' : (coarse ? 'Tap to zoom 2×' : 'Hover to zoom 2× · click for full view'); };
    stage.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { at(e); set(true); } });
    stage.addEventListener('pointermove', e => { if (stage.classList.contains('is-zoom')) at(e); });
    stage.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') set(false); });
    stage.addEventListener('click', e => { if (e.target === btn) return; if (e.pointerType === 'touch' || coarse) { at(e); set(!stage.classList.contains('is-zoom')); } });
    btn.addEventListener('click', e => { e.stopPropagation(); set(!stage.classList.contains('is-zoom')); });
    stage.appendChild(btn);
  }
  window.OBZoom = zoomable;

  /* product page (desktop grid): hover a mockup for a real 2× look at the print detail */
  function pdpZoom() {
    if (matchMedia('(pointer: coarse)').matches || innerWidth < 750) {
      const c = $('media-gallery slideshow-container'); if (c && !$('.ob-tapzoom', c)) { const t = document.createElement('div'); t.className = 'ob-tapzoom'; t.textContent = 'Tap image to zoom'; c.appendChild(t); }
      return;
    }
    $$('media-gallery .media-gallery__grid .product-media-container').forEach(zoomable);
  }

  const boot = () => { reveal(); days(); chips(); pdpZoom(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
